// extracted by mini-css-extract-plugin
export var center = "_4z-2";
export var clickableRow = "_4z-5";
export var expandedRow = "_4z-7";
export var hoverable = "_4z-4";
export var left = "_4z-1";
export var right = "_4z-3";
export var row = "_4z-0";
export var selectedRow = "_4z-6";
export var summaryRow = "_4z-8";